module.exports = __webpack_public_path__ + "media/images/flags/TD-c6483671ef9339ed2ee4c0f1acf64a8c.svg";